import { useMemo, useState } from "react";
import { fitView } from "../../../../helpers/flow";

export default function useDataChainOfCustoryWidget({ data }) {
  const [instance, setInstance] = useState(null);

  const onLoad = (reactFlowInstance) => {
    fitView(reactFlowInstance.fitView, 1);
    setInstance(reactFlowInstance);
  };

  const addElement = ({ id, datastakeId, position, name, image }) => {
    return {
      id,
      targetPosition: 'left',
      className: 'node',
      sourcePosition: 'right',
      style: { width: 180, padding: 8 },
      data: {
        label: (
          <div className="node-cont">
            <div className="img-cont">
              <img alt="img" src={image} />
            </div>
            <div className="name-cont">
              <label className="name">{name}</label>
              <label className="id">{datastakeId}</label>
            </div>
          </div>
        ),
      },
      position,
    }
  }

  const elements = useMemo(() => {
    const _elements = [];

    if (data.subjects) {
      const length = data.subjects.length;
      const max = (length / 2 * 120 * (-1)) + 120 + 60;

      data.subjects.forEach((s, i) => {
        _elements.push(addElement({
          ...s,
          position: { x: data.investor ? 250 : 350, y: max + (i * 120) },
        }));
      })
    }

    if (data.source) {
      _elements.push(addElement({ ...data.source, position: { x: data.investor ? 500 : 650, y: 120 } }));
    }

    if (data.investor) {
      _elements.push(addElement({ ...data.investor, position: { x: 750, y: 120 } }));
    }

    if (data.subjects) {
      if (data.source) {
        data.subjects.forEach((s, i) => {
          _elements.push({
            id: `${s.id}-${data.source.id}`,
            source: s.id,
            target: data.source.id,
          });
        });

        if (data.investor) {
          _elements.push({
            id: `${data.source.id}-${data.investor.id}`,
            source: data.source.id,
            target: data.investor.id,
          })
        }
      }
    }

    return _elements;
  }, [data]);

  return {
    onLoad,
    instance,
    elements,
  };
}
